export default {
  FALHA_CONEXAO: 'Falha na comunicação',
};
